import { SignboardFormat, SignboardSize } from 'sections/LKSection/modules/OrderModule/types'
import { BaseOption, USER_PERMISSION } from 'shared/types/types'

import { WeekDays } from './types'

export const PICKPOINT_DESCRIPTION_MIN = 30
export const PICKPOINT_DESCRIPTION_MAX = 200
export const COURIER_WAY_MAX = 256

export const DEFAULT_START_TIME = '10:00'
export const DEFAULT_END_TIME = '22:00'
export const DEFAULT_GENERAL_TIME = `${DEFAULT_START_TIME}-${DEFAULT_END_TIME}`

export const MIN_WORKING_DAYS = 5
export const MIN_OPENING_HOURS = 6
export const MIN_PUBLIC_PHOTO = 3

export const defaultFileData = {
  url: '',
  size: 0,
  isPublic: false,
}

export const DEFAULT_WEEK_DAYS: WeekDays[] = [
  {
    label: 'Понедельник',
    value: 'monday',
    isDayOff: false,
  },
  {
    label: 'Вторник',
    value: 'tuesday',
    isDayOff: false,
  },
  {
    label: 'Среда',
    value: 'wednesday',
    isDayOff: false,
  },
  {
    label: 'Четверг',
    value: 'thursday',
    isDayOff: false,
  },
  {
    label: 'Пятница',
    value: 'friday',
    isDayOff: false,
  },
  {
    label: 'Суббота',
    value: 'saturday',
    isDayOff: false,
  },
  {
    label: 'Воскресенье',
    value: 'sunday',
    isDayOff: false,
  },
]

export const signboardSizeOptions: BaseOption<SignboardSize>[] = [
  { value: SignboardSize.mini, label: 'Mini' },
  { value: SignboardSize.small, label: '300 (2395х300)' },
  { value: SignboardSize.middle, label: '400 (3218х400)' },
  { value: SignboardSize.big, label: '500 (4034х500)' },
]

export const signboardFormatOptions: BaseOption<SignboardFormat>[] = [
  { value: SignboardFormat.old, label: 'Старый формат' },
  { value: SignboardFormat.new, label: 'Новый формат' },
]

export const OWNER_ROLES = [USER_PERMISSION.PERM_OWNER, USER_PERMISSION.PERM_FIRM_OWNER]
export const EMPLOYEE_ROLES = [USER_PERMISSION.PERM_EMPLOYEE, USER_PERMISSION.PERM_FIRM_EMPLOYEE]
